import type { FC } from "react";
import { CircularProgress } from "@mui/material";

import { useGetOneCpc } from "src/api/sure-api/cpc/useGetOneCpc";
import { type Cpc } from "src/api/sure-api/cpc/useCpcSelector";

import { CpcHierarchyPicker } from "./CpcHierarchyPicker";

interface FormCpcSelectorProps {
    value: string | null | undefined;
    onChange: (code: string | null) => void;
    disabled?: boolean;
    error?: boolean;
    helperText?: string;
    sx?: object;
}

export const FormCpcSelector: FC<FormCpcSelectorProps> = ({
    value,
    onChange,
    disabled = false,
    error = false,
    helperText,
    sx,
}) => {
    const normalizedCode = value?.trim() ?? "";

    const { cpc: fetchedCpc, isLoading } = useGetOneCpc(normalizedCode, {
        enabled: normalizedCode !== "",
    });

    const selectedCpc: Cpc | null = normalizedCode !== "" ? (fetchedCpc ?? null) : null;

    if (normalizedCode !== "" && selectedCpc === null && isLoading) {
        return <CircularProgress size={24} />;
    }

    return (
        <CpcHierarchyPicker
            value={selectedCpc}
            onChange={(cpc) => onChange(cpc?.code ?? null)}
            disabled={disabled}
            error={error}
            helperText={helperText}
            sx={sx}
        />
    );
};
